import { forwardRef } from 'react'
import type { FocusEvent } from 'react'
import { currencyInputToLedgerAmount, formatCurrencyInput } from '@shared/lib/format/currency'
import { TextField } from '../Input/TextField'
import type { TextFieldProps } from '../Input/TextField'

export type CurrencyFieldProps = Omit<
  TextFieldProps,
  'value' | 'defaultValue' | 'onChange' | 'type' | 'inputMode'
> & {
  value: string | number | null | undefined
  currency?: string
  onValueChange: (amount: string) => void
}

export const CurrencyField = forwardRef<HTMLInputElement, CurrencyFieldProps>(
  function CurrencyField(
    { value, currency = 'BRL', onValueChange, onFocus, rightSlot, ...props },
    ref,
  ) {
    function handleFocus(event: FocusEvent<HTMLInputElement>) {
      event.currentTarget.select()
      onFocus?.(event)
    }

    return (
      <TextField
        {...props}
        ref={ref}
        inputMode="numeric"
        value={formatCurrencyInput(value, currency)}
        rightSlot={rightSlot ?? <span>{currency}</span>}
        onFocus={handleFocus}
        onChange={(event) =>
          onValueChange(currencyInputToLedgerAmount(event.target.value, currency))
        }
      />
    )
  },
)
